import { supabase } from './supabase';

export async function createMasterAdmin() {
  try {
    const { data: authData, error: authError } = await supabase.auth.signUp({
      email: 'ShaTera@313safebeds.com',
      password: '123Safe',
    });

    if (authError) {
      console.error('Auth error:', authError);
      return { success: false, error: authError.message };
    }

    if (!authData.user) {
      return { success: false, error: 'No user created' };
    }

    const { error: profileError } = await supabase
      .from('profiles')
      .insert({
        id: authData.user.id,
        email: 'ShaTera@313safebeds.com',
        full_name: 'Master Admin',
        role: 'admin',
      });

    if (profileError) {
      console.error('Profile error:', profileError);
      return { success: false, error: profileError.message };
    }

    const { error: creditsError } = await supabase
      .from('credits')
      .insert({
        user_id: authData.user.id,
        balance: 10000,
        total_earned: 10000,
      });

    if (creditsError) {
      console.error('Credits error:', creditsError);
    }

    console.log('Master admin created successfully!');
    console.log('Email: ShaTera@313safebeds.com');
    console.log('Password: 123Safe');
    console.log('User ID:', authData.user.id);

    return { success: true, userId: authData.user.id };
  } catch (error) {
    console.error('Unexpected error:', error);
    return { success: false, error: String(error) };
  }
}
